import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A temporary switch for AI Activity in organisations without their own AI keys (they run on the platform keys,
 * so the page is hidden by default). Adding `?ailog=enable` to any page URL turns it on for this browser tab until
 * the tab is closed; `?ailog=disable` turns it off. Org admin is still required.
 */
const STORAGE_KEY = 'skeptics_ailog';
const PARAM = 'ailog';

/** Applies an `ailog` URL value, then says whether the switch is on. */
export function applyAiLogParam(search: string): boolean {
  let value: string | null = null;
  try {
    value = new URLSearchParams(search).get(PARAM);
  } catch {
    value = null;
  }
  try {
    if (value === 'enable') sessionStorage.setItem(STORAGE_KEY, '1');
    else if (value === 'disable') sessionStorage.removeItem(STORAGE_KEY);
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return value === 'enable';
  }
}

export function useAiLogOverride(): boolean {
  const { search } = useLocation();
  return useMemo(() => applyAiLogParam(search), [search]);
}
